import type { LDClient } from 'launchdarkly-react-client-sdk';
import { useLDClient } from 'launchdarkly-react-client-sdk';

// This returns a hook that ensures the LDClient is wrapped in <LDProvider>
// The throw used here should not be scary as ldClient only returns undefined if the component is not wrapped.
// So this is always detected in development or in the tests.
// It doesn't mean that it failed to query launchdarkly or anything like that.
// There are other functions for that , namely waitUntilReady and waitForInitialization
export const useEnsureLdClient = (): LDClient => {
  const ldClient = useLDClient();
  if (!ldClient) {
    throw new Error(
      'LaunchDarkly client is not initialized. You need to wrap your component in <LDProvider> ',
    );
  }
  return ldClient;
};
